'use strict';

var Breadcrumb$1 = require('./src/Breadcrumb.js');
var BreadcrumbItem = require('./src/BreadcrumbItem.js');

const Breadcrumb = Breadcrumb$1.Breadcrumb;
Breadcrumb.Item = BreadcrumbItem.Item;

exports.Breadcrumb = Breadcrumb;
//# sourceMappingURL=index.js.map
